module.exports = __webpack_public_path__ + "img/18.ef2a322e.png";